export const recalculateTextAreaHeight = (
	textAreaElement: HTMLTextAreaElement | HTMLInputElement,
	minHeight?: number,
	padding = 0
) => {
	textAreaElement.style.height = "0px";
	const newHeight =
		minHeight !== undefined
			? Math.max(textAreaElement.scrollHeight, minHeight)
			: textAreaElement.scrollHeight;
	textAreaElement.style.height = `${newHeight + padding}px`;
};

export class TextAreaSizeObserver {
	observer: ResizeObserver;
	animationId: number | undefined = undefined;

	constructor() {
		this.observer = new ResizeObserver((entries) => {
			if (this.animationId) {
				cancelAnimationFrame(this.animationId);
			}
			this.animationId = requestAnimationFrame(() => {
				for (const entry of entries) {
					recalculateTextAreaHeight(
						entry.target as HTMLTextAreaElement | HTMLInputElement
					);
				}
			});
		});
	}

	observe(textAreaElement: HTMLTextAreaElement | HTMLInputElement) {
		this.observer.observe(textAreaElement);
	}
	disconnect() {
		this.observer.disconnect();
	}
}

export const preventResrverdKeyEvent = (event: KeyboardEvent) => {
	if (
		event.code === "Backspace" ||
		event.code === "KeyC" ||
		event.code === "KeyZ" ||
		event.code === "KeyV" ||
		event.code === "KeyA" ||
		event.code === "ArrowUp" ||
		event.code === "ArrowDown" ||
		event.code === "ArrowLeft" ||
		event.code === "ArrowRight"
	) {
		event.stopPropagation();
	}
};
